export const REQUIRED_MARK = '*';

export default REQUIRED_MARK;
